import styled from 'styled-components'

export const RelatedItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const RelatedItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.UI.SpacingPx.Space4};
`
